import { createGlobalRoute } from '@townsquare/router/create-route';

import { discoverResource } from './resources/discover-resource';
import { labelFeedResource } from './resources/label-feed-resource';
import { popularFeedResource } from './resources/popular-feed-resource';

export const discoverRouteDefinition = createGlobalRoute({
  exact: true,
  name: 'discover',
  path: '/discover',
  layout: 'home',
  resources: [discoverResource, labelFeedResource, popularFeedResource],
});
